import { quizPalletes } from "constants/Constants";
import React from "react";

const QuizNumbersPallete = ({
  questions = [],
  handleQuestionNumberCLick,
  clickedQuestionIds,
}) => {
  return (
    <>
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "14px",
          color: "#000000",
        }}
        className="mt-5 "
      >
        Question Numbers
      </div>
      <div className="d-flex  flex-wrap">
        {questions?.map((question, index) => {
          return (
            <>
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  background:
                    (clickedQuestionIds?.includes(question?.id) && "#0BBC79") ||
                    (!clickedQuestionIds?.includes(question?.id) && "#BCB9B9"),
                  borderRadius: "2px",
                  color: "#FFFFFF",
                }}
                className="m-2 d-flex justify-content-center align-items-center cursor-pointer"
                onClick={() => {
                  handleQuestionNumberCLick(index + 1);
                }}
              >
                {index + 1}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default QuizNumbersPallete;
